// Capture before the drawer locks the page. Restore after its portal unlocks it.
export function captureDetailReturn(trigger) {
  const view = trigger?.ownerDocument?.defaultView;
  if (!view) return () => {};
  const position = { x: view.scrollX, y: view.scrollY };
  const key = trigger.getAttribute('data-detail-trigger');
  const ancestors = [];
  for (let element = trigger.parentElement; element; element = element.parentElement) {
    ancestors.push({ element, top: element.scrollTop, left: element.scrollLeft });
  }
  return () => view.requestAnimationFrame(() => {
    const current = trigger.isConnected ? trigger : Array.from(view.document.querySelectorAll('[data-detail-trigger]'))
      .find(element => key && element.getAttribute('data-detail-trigger') === key);
    if (current && !current.disabled) current.focus({ preventScroll: true });
    ancestors.forEach(({ element, top, left }) => {
      if (element.isConnected) { element.scrollTop = top; element.scrollLeft = left; }
    });
    view.scrollTo(position.x, position.y);
  });
}
